/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { InternalOrdersList } from '@/app/(client)/orders/-components/InternalOrdersList';
import { internalOrdersQueryOptions } from '@/app/(client)/orders/-hooks/useInternalOrdersList';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(list)/internal-orders/active/',
)({
  validateSearch: (search: Record<string, unknown>) => ({
    aiSummaryId:
      typeof search.aiSummaryId === 'string' ? search.aiSummaryId : undefined,
    aiOrderNumber:
      typeof search.aiOrderNumber === 'string'
        ? search.aiOrderNumber
        : undefined,
    sort: typeof search.sort === 'string' ? search.sort : undefined,
  }),
  loader: () =>
    queryClient.ensureQueryData(
      internalOrdersQueryOptions({ page: 1, limit: 50, isArchived: false }),
    ),
  component: ActiveInternalOrdersPage,
});

function ActiveInternalOrdersPage() {
  return <InternalOrdersList isArchived={false} />;
}
